module.exports = __webpack_public_path__ + "img/footer_icon.12b260c7.png";